var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"markerName",staticStyle:{"border-radius":"2px","background":"rgba(255, 255, 255, 0.7)","justify-content":"center","align-items":"center","display":"flex","padding":"0 3px","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.markerNameInfo.properties.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }